export interface Testimonial {
  id: string
  name: string
  role: string
  company: string
  quote: string
  rating: number
  initials: string
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Marina Costa',
    role: 'Diretora de Operações',
    company: 'Rede Nortec',
    quote:
      'A equipe entregou o projeto de videovigilância em todas as 32 lojas antes do prazo, com suporte técnico impecável. Nossa taxa de furtos caiu drasticamente.',
    rating: 5,
    initials: 'MC',
  },
  {
    id: 't2',
    name: 'Ricardo Almeida',
    role: 'Gerente de Facilities',
    company: 'Torre Zenith',
    quote:
      'O controle de acesso biométrico transformou a gestão do nosso edifício corporativo. Relatórios em tempo real deram total visibilidade para a diretoria.',
    rating: 5,
    initials: 'RA',
  },
  {
    id: 't3',
    name: 'Fernanda Lima',
    role: 'Coordenadora de Segurança',
    company: 'Centro Logístico Aurora',
    quote:
      'Profissionalismo do início ao fim. Conseguimos o AVCB rapidamente graças ao projeto técnico bem documentado e conforme as normas vigentes.',
    rating: 5,
    initials: 'FL',
  },
  {
    id: 't4',
    name: 'Paulo Henrique Souza',
    role: 'CTO',
    company: 'Hospital São Rafael',
    quote:
      'A nova infraestrutura de rede eliminou as instabilidades que afetavam nossos sistemas clínicos. Suporte proativo e monitoramento constante.',
    rating: 5,
    initials: 'PH',
  },
  {
    id: 't5',
    name: 'Juliana Ferreira',
    role: 'Diretora Industrial',
    company: 'Grupo Metabras',
    quote:
      'A consultoria integrada unificou sistemas que antes eram desconexos entre nossas plantas. Reduzimos custos operacionais de forma significativa.',
    rating: 5,
    initials: 'JF',
  },
]
